import { useCallback, useState } from "react";
import LogoMini from "../../../components/icons/LogoMini";
import PlayTriangle from "../../../components/icons/PlayTriangle";
import "../general.scss";
import "./index.scss";
import Popup from "../../../components/Popup";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../../context/DataProvider";
import Analyze from "../../../assets/img/SolutionsIcons/AgilysysAnalyze.svg";
import { Header } from "../../../components/Header";
import { useLocation } from "react-router-dom";

const AnalyzeFPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const [showVideo, setShowVideo] = useState<boolean>(false);

    const { pathname } = useLocation();
    
    return (
      <div className="page splash AnalyzeFPage">
        <div className="page-title">
          <img src={Analyze} alt="" />
        </div>
        <Header />
        <div className="text-blocks">
          <div className="std-text">
            Explore your data to reveal insights that will redefine 
            your operations. Agilysys Analyze gives you quick and 
            simple access to your exisitng POS data.{"\n\n"}
            Easily drill into the reports, slicing and dicing your data 
            to reveal unanticipated trends. Generate reports on the 
            fly, whenever or wherever you need, to answer ad hoc 
            questions, and schedule automatic distribution of 
            reports across the enterprise.{"\n\n"}
          </div>
        </div>
        <div
          className="play-video"
          onClick={() => {
            _logEvent("click", "Solutions - Analyze", "Play Video");
            addFlow("Play Video");
            setShowVideo(true);
          }}
        >
          <PlayTriangle />
          Play Video
        </div>
        <img
          className="img-1"
          src={
            "https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/Analyze1.png"
          }
          alt=""
        />
        <img
          className="img-2"
          src={
            "https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/Analyze2.png"
          }
          alt=""
        />
        <Popup
          showPopup={showVideo}
          setShowPopup={() => setShowVideo(false)}
          disableOffClick={true}
        >
          <>
            {showVideo && (
              <video
                autoPlay
                controls
                src={
                  "https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/videos/Analyze.mp4"
                }
              />
            )}
          </>
        </Popup>
      </div>
    );
}

export default AnalyzeFPage;